import React from 'react'
import { useTranslation } from 'react-i18next'
import { EmptyState } from '@node-space/ui-components'
import { Lottie } from 'components/Animations/SimpleLottie'
import { NetworkConnectionViewTypes } from 'constants/bvnkNetwork'
import { NetworkConnectionViewType } from 'types/bvnkNetwork'

interface ConnectionsEmptyStateProps {
  networkConnectionViewType: NetworkConnectionViewType
}
const ConnectionsEmptyState = ({ networkConnectionViewType }: ConnectionsEmptyStateProps) => {
  const { t } = useTranslation()
  switch (networkConnectionViewType) {
    case NetworkConnectionViewTypes.CONNECTIONS_VIEW:
      return (
        <EmptyState
          testId="empty-state"
          LottiePlayer={<Lottie src="welcome" />}
          title={t('bvnkNetwork.welcomeMessage')}
          description={t('bvnkNetwork.welcomeMessageDescription')}
        />
      )
    case NetworkConnectionViewTypes.RECEIVED_INVITATIONS_VIEW:
      return (
        <EmptyState
          testId="empty-state"
          LottiePlayer={<Lottie src="no-data" />}
          title={t('bvnkNetwork.receivedInvitationEmptyStateHeader')}
          description={t('bvnkNetwork.receivedInvitationEmptyStateDescription')}
        />
      )
    case NetworkConnectionViewTypes.SENT_INVITATIONS_VIEW:
      return (
        <EmptyState
          testId="empty-state"
          LottiePlayer={<Lottie src="no-data" />}
          title={t('bvnkNetwork.sentInvitationEmptyStateHeader')}
          description={t('bvnkNetwork.sentInvitationEmptyStateDescription')}
        />
      )
    default:
      return null
  }
}

export default ConnectionsEmptyState
